<template>
  <v-container>
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="12">
        <v-card outlined>
          <v-card-text>
            <v-row class="black--text">
              <v-col cols="12" md="12" v-if="alertdata.show">
                <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
              </v-col>
              <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </v-col>
              <v-col cols="12" md="12" v-if="!loading.detail && detaildata.length > 0">
                <v-row>
                  <v-col cols="12" md="12">
                    <p class="subtitle-1">
                      <span class="font-weight-bold">{{ detaildata[0].vocab_en }}</span> = {{ detaildata[0].vocab_id }} ({{ detaildata[0].part_of }})
                    </p>
                    <p class="subtitle-2">
                      <span class="font-italic">{{ detaildata[0].desc_en }}</span>
                    </p>
                    <p class="subtitle-2">
                      <span>({{ detaildata[0].desc_id }})</span>
                    </p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions v-if="!loading.detail && detaildata.length > 0">
            <v-btn
              icon
              @click="$router.go(-1)"
              exact>
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <span>Back</span>
            <v-spacer></v-spacer>
            <v-btn
              plain outlined
              color="primary"
              class="px-0">
              <b>{{ detaildata[0].count }}</b>
              <v-icon>mdi-eye</v-icon>
            </v-btn>
            <v-btn
              plain outlined
              :color="isFavorite ? 'red' : ''"
              @click="addFavorite(detaildata[0], isFavorite)"
              class="px-0">
              <v-icon>mdi-heart</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Kamusdetail',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    detaildata: [],
    panduan: null,
    paramvocab: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      vocab: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
  }),
  watch: {
    '$route.query.vocab'(val) {
      if (val) {
        this.check.vocab = val;
        this.getKamus();
      }
    },
  },
  mounted() {
    if (this.$route.query.vocab && this.$route.query.vocab !== '') {
      this.check.vocab = this.$route.query.vocab;
      this.getKamus();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'isFavorite',
    ]),
  },
  methods: {
    getKamus() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.vocab) {
        this.axios
          .get(
            this.api + '/public/kamus/' + this.check.vocab,
            {
              params: this.paramvocab,
              headers: {
                Authorization: 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.$store.commit('UPDATE_TITLE', resdata.data[0].vocab_en);
                // update favorite
                this.$store.commit('UPDATE_FAV', resdata.data[0].id_vocab);
                // add history
                const historyNew = {
                  id_vocab: resdata.data[0].id_vocab,
                  vocab_en: resdata.data[0].vocab_en,
                };
                this.$store.commit('ADD_HISTORY', historyNew);
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Berita tidak ditemukan!';
      }
    },
    addFavorite(datafav, status) {
      // favorite
      const favNew = {
        id_vocab: datafav.id_vocab,
        vocab_en: datafav.vocab_en,
      };
      if (status === true) {
        // delete
        this.$store.commit('DEL_FAV', favNew);
      } else {
        // add
        this.$store.commit('ADD_FAV', favNew);
      }
      // update favorite
      this.$store.commit('UPDATE_FAV', datafav.id_vocab);
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
